export const SKU_PACKAGE_MAP: Record<number, string | undefined> = {
  100: 'Torso',
  200: 'Head + torso',
  300: 'Whole body',
  350: 'Enhanced Comprehensive',
  370: 'Enhanced Screening + WB',
  400: 'WB + consult',
  500: 'R&D',
};
